<template>
    <div>
        <div class="" style="border: 1px solid #F5F7FA;">
            <div class="container top-header">
                <img src="../assets/superkids/superkid-logo.svg" alt="logo">

                <button class="btn" @click="routeTo('/volunteer-register')">Become a volunteer</button>
            </div>
        </div>

        <div class="hero-section">
            <div class="container">
                <div class="row">
                <div class="col-md-8">
                    <div class="container hero-text-holder">
                        <img class="shine" src="../assets/superkids/sunshine.svg" alt="shine">
                        <h3>Every Child is a star ✨</h3>
                        <p>
                            Shelta SuperKids is a national community program where volunteers help discover, guide, and celebrate children’s talents.
                        </p>
                        <div style="text-align: left;">
                            <button class="btn becomeBtn" @click="routeTo('/volunteer-register')">Become a volunteer</button>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>

        <div class="whatIsSuperKidHolder">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <div class="left-what">
                            <h3>What Is Shelta SuperKids?</h3>
                            <p>Shelta SuperKids is a national platform designed to discover, celebrate and empower Nigerian children. It blends culture, creativity, talent, language, STEM and community impact into a vibrant 8-week season of challenges, recognition and celebration.</p>
                            <p>The program works directly within local communities by partnering with:</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="right-what">
                            <div class="right-what-list">
                                <span>
                                    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7867 5.60048C16.3605 5.96365 16.1474 6.14527 15.9199 6.2978C15.3982 6.64745 14.8123 6.89012 14.1962 7.01176C13.9274 7.06484 13.6483 7.0871 13.0901 7.13164C11.6877 7.24357 10.9865 7.29952 10.4015 7.50616C9.0484 7.98408 7.98408 9.0484 7.50616 10.4015C7.29952 10.9865 7.24357 11.6877 7.13164 13.0901C7.0871 13.6483 7.06484 13.9274 7.01176 14.1962C6.89012 14.8123 6.64745 15.3982 6.2978 15.9199C6.14527 16.1474 5.96367 16.3605 5.60048 16.7867C4.68796 17.8575 4.23168 18.3929 3.96414 18.9527C3.34529 20.2475 3.34529 21.7525 3.96414 23.0473C4.2317 23.6072 4.68796 24.1425 5.60048 25.2133C5.96362 25.6394 6.14527 25.8526 6.2978 26.0801C6.64745 26.6018 6.89012 27.1877 7.01176 27.8038C7.06484 28.0726 7.0871 28.3518 7.13164 28.9098C7.24357 30.3123 7.29952 31.0135 7.50616 31.5985C7.98408 32.9516 9.0484 34.016 10.4015 34.4939C10.9865 34.7004 11.6877 34.7564 13.0901 34.8684C13.6483 34.9129 13.9274 34.9353 14.1962 34.9883C14.8123 35.1099 15.3982 35.3526 15.9199 35.7023C16.1474 35.8547 16.3605 36.0364 16.7867 36.3995C17.8575 37.3121 18.3929 37.7683 18.9527 38.0359C20.2475 38.6547 21.7525 38.6547 23.0473 38.0359C23.6072 37.7683 24.1425 37.3121 25.2133 36.3995C25.6394 36.0364 25.8526 35.8547 26.0801 35.7023C26.6018 35.3526 27.1877 35.1099 27.8038 34.9883C28.0726 34.9353 28.3518 34.9129 28.9098 34.8684C30.3123 34.7564 31.0135 34.7004 31.5985 34.4939C32.9516 34.016 34.016 32.9516 34.4939 31.5985C34.7004 31.0135 34.7564 30.3123 34.8684 28.9098C34.9129 28.3518 34.9353 28.0726 34.9883 27.8038C35.1099 27.1877 35.3526 26.6018 35.7023 26.0801C35.8547 25.8526 36.0364 25.6394 36.3995 25.2133C37.3121 24.1425 37.7683 23.6072 38.0359 23.0473C38.6547 21.7525 38.6547 20.2475 38.0359 18.9527C37.7683 18.3929 37.3121 17.8575 36.3995 16.7867C36.0364 16.3605 35.8547 16.1474 35.7023 15.9199C35.3526 15.3982 35.1099 14.8123 34.9883 14.1962C34.9353 13.9274 34.9129 13.6483 34.8684 13.0901C34.7564 11.6877 34.7004 10.9865 34.4939 10.4015C34.016 9.0484 32.9516 7.98408 31.5985 7.50616C31.0135 7.29952 30.3123 7.24357 28.9098 7.13164C28.3518 7.0871 28.0726 7.06484 27.8038 7.01176C27.1877 6.89012 26.6018 6.64745 26.0801 6.2978C25.8526 6.14527 25.6394 5.96367 25.2133 5.60048C24.1425 4.68796 23.6072 4.2317 23.0473 3.96414C21.7525 3.34529 20.2475 3.34529 18.9527 3.96414C18.3929 4.23168 17.8575 4.68796 16.7867 5.60048ZM28.6536 17.2605C29.2098 16.7043 29.2098 15.8025 28.6536 15.2463C28.0975 14.6901 27.1955 14.6901 26.6394 15.2463L18.1515 23.7342L15.3606 20.9433C14.8044 20.3872 13.9026 20.3872 13.3464 20.9433C12.7902 21.4995 12.7902 22.4012 13.3464 22.9576L17.1444 26.7556C17.7006 27.3117 18.6023 27.3117 19.1587 26.7556L28.6536 17.2605Z" fill="#F88159"/>
                                    </svg>
                                </span>
                                <div>
                                    <h5>Parents and Caregivers</h5>
                                    <h6>Helping families nurture children’s talents at home and in their communities.</h6>
                                </div>
                            </div>
                            
                            
                            <div class="right-what-list">
                                <span>
                                    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7867 5.60048C16.3605 5.96365 16.1474 6.14527 15.9199 6.2978C15.3982 6.64745 14.8123 6.89012 14.1962 7.01176C13.9274 7.06484 13.6483 7.0871 13.0901 7.13164C11.6877 7.24357 10.9865 7.29952 10.4015 7.50616C9.0484 7.98408 7.98408 9.0484 7.50616 10.4015C7.29952 10.9865 7.24357 11.6877 7.13164 13.0901C7.0871 13.6483 7.06484 13.9274 7.01176 14.1962C6.89012 14.8123 6.64745 15.3982 6.2978 15.9199C6.14527 16.1474 5.96367 16.3605 5.60048 16.7867C4.68796 17.8575 4.23168 18.3929 3.96414 18.9527C3.34529 20.2475 3.34529 21.7525 3.96414 23.0473C4.2317 23.6072 4.68796 24.1425 5.60048 25.2133C5.96362 25.6394 6.14527 25.8526 6.2978 26.0801C6.64745 26.6018 6.89012 27.1877 7.01176 27.8038C7.06484 28.0726 7.0871 28.3518 7.13164 28.9098C7.24357 30.3123 7.29952 31.0135 7.50616 31.5985C7.98408 32.9516 9.0484 34.016 10.4015 34.4939C10.9865 34.7004 11.6877 34.7564 13.0901 34.8684C13.6483 34.9129 13.9274 34.9353 14.1962 34.9883C14.8123 35.1099 15.3982 35.3526 15.9199 35.7023C16.1474 35.8547 16.3605 36.0364 16.7867 36.3995C17.8575 37.3121 18.3929 37.7683 18.9527 38.0359C20.2475 38.6547 21.7525 38.6547 23.0473 38.0359C23.6072 37.7683 24.1425 37.3121 25.2133 36.3995C25.6394 36.0364 25.8526 35.8547 26.0801 35.7023C26.6018 35.3526 27.1877 35.1099 27.8038 34.9883C28.0726 34.9353 28.3518 34.9129 28.9098 34.8684C30.3123 34.7564 31.0135 34.7004 31.5985 34.4939C32.9516 34.016 34.016 32.9516 34.4939 31.5985C34.7004 31.0135 34.7564 30.3123 34.8684 28.9098C34.9129 28.3518 34.9353 28.0726 34.9883 27.8038C35.1099 27.1877 35.3526 26.6018 35.7023 26.0801C35.8547 25.8526 36.0364 25.6394 36.3995 25.2133C37.3121 24.1425 37.7683 23.6072 38.0359 23.0473C38.6547 21.7525 38.6547 20.2475 38.0359 18.9527C37.7683 18.3929 37.3121 17.8575 36.3995 16.7867C36.0364 16.3605 35.8547 16.1474 35.7023 15.9199C35.3526 15.3982 35.1099 14.8123 34.9883 14.1962C34.9353 13.9274 34.9129 13.6483 34.8684 13.0901C34.7564 11.6877 34.7004 10.9865 34.4939 10.4015C34.016 9.0484 32.9516 7.98408 31.5985 7.50616C31.0135 7.29952 30.3123 7.24357 28.9098 7.13164C28.3518 7.0871 28.0726 7.06484 27.8038 7.01176C27.1877 6.89012 26.6018 6.64745 26.0801 6.2978C25.8526 6.14527 25.6394 5.96367 25.2133 5.60048C24.1425 4.68796 23.6072 4.2317 23.0473 3.96414C21.7525 3.34529 20.2475 3.34529 18.9527 3.96414C18.3929 4.23168 17.8575 4.68796 16.7867 5.60048ZM28.6536 17.2605C29.2098 16.7043 29.2098 15.8025 28.6536 15.2463C28.0975 14.6901 27.1955 14.6901 26.6394 15.2463L18.1515 23.7342L15.3606 20.9433C14.8044 20.3872 13.9026 20.3872 13.3464 20.9433C12.7902 21.4995 12.7902 22.4012 13.3464 22.9576L17.1444 26.7556C17.7006 27.3117 18.6023 27.3117 19.1587 26.7556L28.6536 17.2605Z" fill="#2AB3E6"/>
                                    </svg>

                                </span>
                                <div>
                                    <h5>Schools & Teachers</h5>
                                    <h6>Partnering with educators to guide and celebrate young talents beyond the classroom.</h6>
                                </div>
                            </div>
                            
                            
                            <div class="right-what-list">
                                <span>
                                    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7867 5.60048C16.3605 5.96365 16.1474 6.14527 15.9199 6.2978C15.3982 6.64745 14.8123 6.89012 14.1962 7.01176C13.9274 7.06484 13.6483 7.0871 13.0901 7.13164C11.6877 7.24357 10.9865 7.29952 10.4015 7.50616C9.0484 7.98408 7.98408 9.0484 7.50616 10.4015C7.29952 10.9865 7.24357 11.6877 7.13164 13.0901C7.0871 13.6483 7.06484 13.9274 7.01176 14.1962C6.89012 14.8123 6.64745 15.3982 6.2978 15.9199C6.14527 16.1474 5.96367 16.3605 5.60048 16.7867C4.68796 17.8575 4.23168 18.3929 3.96414 18.9527C3.34529 20.2475 3.34529 21.7525 3.96414 23.0473C4.2317 23.6072 4.68796 24.1425 5.60048 25.2133C5.96362 25.6394 6.14527 25.8526 6.2978 26.0801C6.64745 26.6018 6.89012 27.1877 7.01176 27.8038C7.06484 28.0726 7.0871 28.3518 7.13164 28.9098C7.24357 30.3123 7.29952 31.0135 7.50616 31.5985C7.98408 32.9516 9.0484 34.016 10.4015 34.4939C10.9865 34.7004 11.6877 34.7564 13.0901 34.8684C13.6483 34.9129 13.9274 34.9353 14.1962 34.9883C14.8123 35.1099 15.3982 35.3526 15.9199 35.7023C16.1474 35.8547 16.3605 36.0364 16.7867 36.3995C17.8575 37.3121 18.3929 37.7683 18.9527 38.0359C20.2475 38.6547 21.7525 38.6547 23.0473 38.0359C23.6072 37.7683 24.1425 37.3121 25.2133 36.3995C25.6394 36.0364 25.8526 35.8547 26.0801 35.7023C26.6018 35.3526 27.1877 35.1099 27.8038 34.9883C28.0726 34.9353 28.3518 34.9129 28.9098 34.8684C30.3123 34.7564 31.0135 34.7004 31.5985 34.4939C32.9516 34.016 34.016 32.9516 34.4939 31.5985C34.7004 31.0135 34.7564 30.3123 34.8684 28.9098C34.9129 28.3518 34.9353 28.0726 34.9883 27.8038C35.1099 27.1877 35.3526 26.6018 35.7023 26.0801C35.8547 25.8526 36.0364 25.6394 36.3995 25.2133C37.3121 24.1425 37.7683 23.6072 38.0359 23.0473C38.6547 21.7525 38.6547 20.2475 38.0359 18.9527C37.7683 18.3929 37.3121 17.8575 36.3995 16.7867C36.0364 16.3605 35.8547 16.1474 35.7023 15.9199C35.3526 15.3982 35.1099 14.8123 34.9883 14.1962C34.9353 13.9274 34.9129 13.6483 34.8684 13.0901C34.7564 11.6877 34.7004 10.9865 34.4939 10.4015C34.016 9.0484 32.9516 7.98408 31.5985 7.50616C31.0135 7.29952 30.3123 7.24357 28.9098 7.13164C28.3518 7.0871 28.0726 7.06484 27.8038 7.01176C27.1877 6.89012 26.6018 6.64745 26.0801 6.2978C25.8526 6.14527 25.6394 5.96367 25.2133 5.60048C24.1425 4.68796 23.6072 4.2317 23.0473 3.96414C21.7525 3.34529 20.2475 3.34529 18.9527 3.96414C18.3929 4.23168 17.8575 4.68796 16.7867 5.60048ZM28.6536 17.2605C29.2098 16.7043 29.2098 15.8025 28.6536 15.2463C28.0975 14.6901 27.1955 14.6901 26.6394 15.2463L18.1515 23.7342L15.3606 20.9433C14.8044 20.3872 13.9026 20.3872 13.3464 20.9433C12.7902 21.4995 12.7902 22.4012 13.3464 22.9576L17.1444 26.7556C17.7006 27.3117 18.6023 27.3117 19.1587 26.7556L28.6536 17.2605Z" fill="#00C8B3"/>
                                    </svg>

                                </span>
                                <div>
                                    <h5>Churches, Mosques & Faith-Based Groups</h5>
                                    <h6>Working with faith communities to support children in safe, trusted spaces.</h6>
                                </div>
                            </div>
                            
                            <div class="right-what-list">
                                <span>
                                    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.7867 5.60048C16.3605 5.96365 16.1474 6.14527 15.9199 6.2978C15.3982 6.64745 14.8123 6.89012 14.1962 7.01176C13.9274 7.06484 13.6483 7.0871 13.0901 7.13164C11.6877 7.24357 10.9865 7.29952 10.4015 7.50616C9.0484 7.98408 7.98408 9.0484 7.50616 10.4015C7.29952 10.9865 7.24357 11.6877 7.13164 13.0901C7.0871 13.6483 7.06484 13.9274 7.01176 14.1962C6.89012 14.8123 6.64745 15.3982 6.2978 15.9199C6.14527 16.1474 5.96367 16.3605 5.60048 16.7867C4.68796 17.8575 4.23168 18.3929 3.96414 18.9527C3.34529 20.2475 3.34529 21.7525 3.96414 23.0473C4.2317 23.6072 4.68796 24.1425 5.60048 25.2133C5.96362 25.6394 6.14527 25.8526 6.2978 26.0801C6.64745 26.6018 6.89012 27.1877 7.01176 27.8038C7.06484 28.0726 7.0871 28.3518 7.13164 28.9098C7.24357 30.3123 7.29952 31.0135 7.50616 31.5985C7.98408 32.9516 9.0484 34.016 10.4015 34.4939C10.9865 34.7004 11.6877 34.7564 13.0901 34.8684C13.6483 34.9129 13.9274 34.9353 14.1962 34.9883C14.8123 35.1099 15.3982 35.3526 15.9199 35.7023C16.1474 35.8547 16.3605 36.0364 16.7867 36.3995C17.8575 37.3121 18.3929 37.7683 18.9527 38.0359C20.2475 38.6547 21.7525 38.6547 23.0473 38.0359C23.6072 37.7683 24.1425 37.3121 25.2133 36.3995C25.6394 36.0364 25.8526 35.8547 26.0801 35.7023C26.6018 35.3526 27.1877 35.1099 27.8038 34.9883C28.0726 34.9353 28.3518 34.9129 28.9098 34.8684C30.3123 34.7564 31.0135 34.7004 31.5985 34.4939C32.9516 34.016 34.016 32.9516 34.4939 31.5985C34.7004 31.0135 34.7564 30.3123 34.8684 28.9098C34.9129 28.3518 34.9353 28.0726 34.9883 27.8038C35.1099 27.1877 35.3526 26.6018 35.7023 26.0801C35.8547 25.8526 36.0364 25.6394 36.3995 25.2133C37.3121 24.1425 37.7683 23.6072 38.0359 23.0473C38.6547 21.7525 38.6547 20.2475 38.0359 18.9527C37.7683 18.3929 37.3121 17.8575 36.3995 16.7867C36.0364 16.3605 35.8547 16.1474 35.7023 15.9199C35.3526 15.3982 35.1099 14.8123 34.9883 14.1962C34.9353 13.9274 34.9129 13.6483 34.8684 13.0901C34.7564 11.6877 34.7004 10.9865 34.4939 10.4015C34.016 9.0484 32.9516 7.98408 31.5985 7.50616C31.0135 7.29952 30.3123 7.24357 28.9098 7.13164C28.3518 7.0871 28.0726 7.06484 27.8038 7.01176C27.1877 6.89012 26.6018 6.64745 26.0801 6.2978C25.8526 6.14527 25.6394 5.96367 25.2133 5.60048C24.1425 4.68796 23.6072 4.2317 23.0473 3.96414C21.7525 3.34529 20.2475 3.34529 18.9527 3.96414C18.3929 4.23168 17.8575 4.68796 16.7867 5.60048ZM28.6536 17.2605C29.2098 16.7043 29.2098 15.8025 28.6536 15.2463C28.0975 14.6901 27.1955 14.6901 26.6394 15.2463L18.1515 23.7342L15.3606 20.9433C14.8044 20.3872 13.9026 20.3872 13.3464 20.9433C12.7902 21.4995 12.7902 22.4012 13.3464 22.9576L17.1444 26.7556C17.7006 27.3117 18.6023 27.3117 19.1587 26.7556L28.6536 17.2605Z" fill="#0A77AE"/>
                                    </svg>

                                </span>
                                <div>
                                    <h5>Community Associations & Youth Leaders</h5>
                                    <h6>Working with local leaders to build strong community support for children.</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="why-volunteer-holder">
            <div class="container">
                <h3 class="standard-header">Why Volunteer With SuperKids?</h3>
                <h6 class="sub-header col-md-8 m-auto">
                    Volunteers are the heart of the SuperKids program. By volunteering, you are not only supporting children, you are strengthening families and communities.
                </h6>
                <div class="why-cards hide-scrollbar">
                    <div class="why-card orange-card">
                        <div>
                            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.186 31.9314C9.27183 28.1452 3.5 23.6983 3.5 15.9894C3.5 7.47923 13.1253 1.44401 21 9.62556L24.5 13.1232C25.0126 13.6357 25.8437 13.6355 26.3562 13.1228C26.8686 12.6102 26.8685 11.7792 26.3559 11.2667L22.9749 7.88691C30.3949 2.45486 38.5 8.18009 38.5 15.9894C38.5 23.6983 32.7281 28.1452 27.814 31.9314C27.3033 32.3249 26.8018 32.7113 26.317 33.0935C24.5 34.5259 22.75 35.8745 21 35.8745C19.25 35.8745 17.5 34.5259 15.683 33.0935C15.1982 32.7113 14.6967 32.3249 14.186 31.9314Z" fill="#F8805D"/>
                            </svg>
                        </div>
                        <h5>Be a Role Model</h5>
                        <h6>Inspire confidence, creativity, and growth in children.</h6>
                    </div>
                    <div class="why-card blue-card">
                        <div>
                            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.186 31.9314C9.27183 28.1452 3.5 23.6983 3.5 15.9894C3.5 7.47923 13.1253 1.44401 21 9.62556L24.5 13.1232C25.0126 13.6357 25.8437 13.6355 26.3562 13.1228C26.8686 12.6102 26.8685 11.7792 26.3559 11.2667L22.9749 7.88691C30.3949 2.45486 38.5 8.18009 38.5 15.9894C38.5 23.6983 32.7281 28.1452 27.814 31.9314C27.3033 32.3249 26.8018 32.7113 26.317 33.0935C24.5 34.5259 22.75 35.8745 21 35.8745C19.25 35.8745 17.5 34.5259 15.683 33.0935C15.1982 32.7113 14.6967 32.3249 14.186 31.9314Z" fill="#0870AD"/>
                            </svg>
                        </div>
                        <h5>Empower Families</h5>
                        <h6>Help parents and caregivers guide children’s learning.</h6>
                    </div>
                    <div class="why-card green-card">
                        <div>
                            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.186 31.9314C9.27183 28.1452 3.5 23.6983 3.5 15.9894C3.5 7.47923 13.1253 1.44401 21 9.62556L24.5 13.1232C25.0126 13.6357 25.8437 13.6355 26.3562 13.1228C26.8686 12.6102 26.8685 11.7792 26.3559 11.2667L22.9749 7.88691C30.3949 2.45486 38.5 8.18009 38.5 15.9894C38.5 23.6983 32.7281 28.1452 27.814 31.9314C27.3033 32.3249 26.8018 32.7113 26.317 33.0935C24.5 34.5259 22.75 35.8745 21 35.8745C19.25 35.8745 17.5 34.5259 15.683 33.0935C15.1982 32.7113 14.6967 32.3249 14.186 31.9314Z" fill="#00C8B3"/>
                            </svg>

                        </div>
                        <h5>Stronger Communities</h5>
                        <h6>Unite families and leaders for child growth.</h6>
                    </div>
                    <div class="why-card marginta-card">
                        <div>
                            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.186 31.9314C9.27183 28.1452 3.5 23.6983 3.5 15.9894C3.5 7.47923 13.1253 1.44401 21 9.62556L24.5 13.1232C25.0126 13.6357 25.8437 13.6355 26.3562 13.1228C26.8686 12.6102 26.8685 11.7792 26.3559 11.2667L22.9749 7.88691C30.3949 2.45486 38.5 8.18009 38.5 15.9894C38.5 23.6983 32.7281 28.1452 27.814 31.9314C27.3033 32.3249 26.8018 32.7113 26.317 33.0935C24.5 34.5259 22.75 35.8745 21 35.8745C19.25 35.8745 17.5 34.5259 15.683 33.0935C15.1982 32.7113 14.6967 32.3249 14.186 31.9314Z" fill="#9E4982"/>
                            </svg>
                        </div>
                        <h5>Guide the challenges</h5>
                        <h6>Support fair evaluation across SuperKids challenge categories.</h6>
                    </div>
                    <div class="why-card sky-blue-card">
                        <div>
                            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14.186 31.9314C9.27183 28.1452 3.5 23.6983 3.5 15.9894C3.5 7.47923 13.1253 1.44401 21 9.62556L24.5 13.1232C25.0126 13.6357 25.8437 13.6355 26.3562 13.1228C26.8686 12.6102 26.8685 11.7792 26.3559 11.2667L22.9749 7.88691C30.3949 2.45486 38.5 8.18009 38.5 15.9894C38.5 23.6983 32.7281 28.1452 27.814 31.9314C27.3033 32.3249 26.8018 32.7113 26.317 33.0935C24.5 34.5259 22.75 35.8745 21 35.8745C19.25 35.8745 17.5 34.5259 15.683 33.0935C15.1982 32.7113 14.6967 32.3249 14.186 31.9314Z" fill="#5FC6EC"/>
                            </svg>
                        </div>
                        <h5>Drive Social Impact</h5>
                        <h6>Contribute to a program with real, trackable outcomes.</h6>
                    </div>
                </div>

                <div class="mt-5">
                    <button class="btn becomeBtn" @click="routeTo('/volunteer-register')">Become a volunteer</button>
                </div>
            </div>
        </div>
        <div class="who_can_apply">
            <div class="container">
                <h3 class="standard-header">Who Can Apply as a Volunteer?</h3>
                <h6 class="sub-header col-md-8 m-auto">
                    We welcome volunteers from diverse backgrounds who are already connected to children and communities.
                </h6>
                <div class="row align-items-center mt-5">
                    <div class="col-md-6">
                        <img class="w-100" src="../assets/superkids/people.png" alt="people">
                    </div>
                    <div class="col-md-6">
                        <div class="who-can-item mt-5">
                            <div class="orange-bg">
                                <div class="d-flex mb-2">
                                    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7867 5.60048C16.3605 5.96365 16.1474 6.14527 15.9199 6.2978C15.3982 6.64745 14.8123 6.89012 14.1962 7.01176C13.9274 7.06484 13.6483 7.0871 13.0901 7.13164C11.6877 7.24357 10.9865 7.29952 10.4015 7.50616C9.0484 7.98408 7.98408 9.0484 7.50616 10.4015C7.29952 10.9865 7.24357 11.6877 7.13164 13.0901C7.0871 13.6483 7.06484 13.9274 7.01176 14.1962C6.89012 14.8123 6.64745 15.3982 6.2978 15.9199C6.14527 16.1474 5.96367 16.3605 5.60048 16.7867C4.68796 17.8575 4.23168 18.3929 3.96414 18.9527C3.34529 20.2475 3.34529 21.7525 3.96414 23.0473C4.2317 23.6072 4.68796 24.1425 5.60048 25.2133C5.96362 25.6394 6.14527 25.8526 6.2978 26.0801C6.64745 26.6018 6.89012 27.1877 7.01176 27.8038C7.06484 28.0726 7.0871 28.3518 7.13164 28.9098C7.24357 30.3123 7.29952 31.0135 7.50616 31.5985C7.98408 32.9516 9.0484 34.016 10.4015 34.4939C10.9865 34.7004 11.6877 34.7564 13.0901 34.8684C13.6483 34.9129 13.9274 34.9353 14.1962 34.9883C14.8123 35.1099 15.3982 35.3526 15.9199 35.7023C16.1474 35.8547 16.3605 36.0364 16.7867 36.3995C17.8575 37.3121 18.3929 37.7683 18.9527 38.0359C20.2475 38.6547 21.7525 38.6547 23.0473 38.0359C23.6072 37.7683 24.1425 37.3121 25.2133 36.3995C25.6394 36.0364 25.8526 35.8547 26.0801 35.7023C26.6018 35.3526 27.1877 35.1099 27.8038 34.9883C28.0726 34.9353 28.3518 34.9129 28.9098 34.8684C30.3123 34.7564 31.0135 34.7004 31.5985 34.4939C32.9516 34.016 34.016 32.9516 34.4939 31.5985C34.7004 31.0135 34.7564 30.3123 34.8684 28.9098C34.9129 28.3518 34.9353 28.0726 34.9883 27.8038C35.1099 27.1877 35.3526 26.6018 35.7023 26.0801C35.8547 25.8526 36.0364 25.6394 36.3995 25.2133C37.3121 24.1425 37.7683 23.6072 38.0359 23.0473C38.6547 21.7525 38.6547 20.2475 38.0359 18.9527C37.7683 18.3929 37.3121 17.8575 36.3995 16.7867C36.0364 16.3605 35.8547 16.1474 35.7023 15.9199C35.3526 15.3982 35.1099 14.8123 34.9883 14.1962C34.9353 13.9274 34.9129 13.6483 34.8684 13.0901C34.7564 11.6877 34.7004 10.9865 34.4939 10.4015C34.016 9.0484 32.9516 7.98408 31.5985 7.50616C31.0135 7.29952 30.3123 7.24357 28.9098 7.13164C28.3518 7.0871 28.0726 7.06484 27.8038 7.01176C27.1877 6.89012 26.6018 6.64745 26.0801 6.2978C25.8526 6.14527 25.6394 5.96367 25.2133 5.60048C24.1425 4.68796 23.6072 4.2317 23.0473 3.96414C21.7525 3.34529 20.2475 3.34529 18.9527 3.96414C18.3929 4.23168 17.8575 4.68796 16.7867 5.60048ZM28.6536 17.2605C29.2098 16.7043 29.2098 15.8025 28.6536 15.2463C28.0975 14.6901 27.1955 14.6901 26.6394 15.2463L18.1515 23.7342L15.3606 20.9433C14.8044 20.3872 13.9026 20.3872 13.3464 20.9433C12.7902 21.4995 12.7902 22.4012 13.3464 22.9576L17.1444 26.7556C17.7006 27.3117 18.6023 27.3117 19.1587 26.7556L28.6536 17.2605Z" fill="#F8805D"/>
                                    </svg>
                                </div>
                                <h5>Educators & Learning Facilitators</h5>
                                <h6>Shelta SuperKids is a national platform designed to discover, celebrate and empower Nigerian </h6>
                            </div>
                        </div>

                        <div>
                            <div class="marginta-bg">
                                <div class="d-flex mb-2">
                                    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7867 5.60048C16.3605 5.96365 16.1474 6.14527 15.9199 6.2978C15.3982 6.64745 14.8123 6.89012 14.1962 7.01176C13.9274 7.06484 13.6483 7.0871 13.0901 7.13164C11.6877 7.24357 10.9865 7.29952 10.4015 7.50616C9.0484 7.98408 7.98408 9.0484 7.50616 10.4015C7.29952 10.9865 7.24357 11.6877 7.13164 13.0901C7.0871 13.6483 7.06484 13.9274 7.01176 14.1962C6.89012 14.8123 6.64745 15.3982 6.2978 15.9199C6.14527 16.1474 5.96367 16.3605 5.60048 16.7867C4.68796 17.8575 4.23168 18.3929 3.96414 18.9527C3.34529 20.2475 3.34529 21.7525 3.96414 23.0473C4.2317 23.6072 4.68796 24.1425 5.60048 25.2133C5.96362 25.6394 6.14527 25.8526 6.2978 26.0801C6.64745 26.6018 6.89012 27.1877 7.01176 27.8038C7.06484 28.0726 7.0871 28.3518 7.13164 28.9098C7.24357 30.3123 7.29952 31.0135 7.50616 31.5985C7.98408 32.9516 9.0484 34.016 10.4015 34.4939C10.9865 34.7004 11.6877 34.7564 13.0901 34.8684C13.6483 34.9129 13.9274 34.9353 14.1962 34.9883C14.8123 35.1099 15.3982 35.3526 15.9199 35.7023C16.1474 35.8547 16.3605 36.0364 16.7867 36.3995C17.8575 37.3121 18.3929 37.7683 18.9527 38.0359C20.2475 38.6547 21.7525 38.6547 23.0473 38.0359C23.6072 37.7683 24.1425 37.3121 25.2133 36.3995C25.6394 36.0364 25.8526 35.8547 26.0801 35.7023C26.6018 35.3526 27.1877 35.1099 27.8038 34.9883C28.0726 34.9353 28.3518 34.9129 28.9098 34.8684C30.3123 34.7564 31.0135 34.7004 31.5985 34.4939C32.9516 34.016 34.016 32.9516 34.4939 31.5985C34.7004 31.0135 34.7564 30.3123 34.8684 28.9098C34.9129 28.3518 34.9353 28.0726 34.9883 27.8038C35.1099 27.1877 35.3526 26.6018 35.7023 26.0801C35.8547 25.8526 36.0364 25.6394 36.3995 25.2133C37.3121 24.1425 37.7683 23.6072 38.0359 23.0473C38.6547 21.7525 38.6547 20.2475 38.0359 18.9527C37.7683 18.3929 37.3121 17.8575 36.3995 16.7867C36.0364 16.3605 35.8547 16.1474 35.7023 15.9199C35.3526 15.3982 35.1099 14.8123 34.9883 14.1962C34.9353 13.9274 34.9129 13.6483 34.8684 13.0901C34.7564 11.6877 34.7004 10.9865 34.4939 10.4015C34.016 9.0484 32.9516 7.98408 31.5985 7.50616C31.0135 7.29952 30.3123 7.24357 28.9098 7.13164C28.3518 7.0871 28.0726 7.06484 27.8038 7.01176C27.1877 6.89012 26.6018 6.64745 26.0801 6.2978C25.8526 6.14527 25.6394 5.96367 25.2133 5.60048C24.1425 4.68796 23.6072 4.2317 23.0473 3.96414C21.7525 3.34529 20.2475 3.34529 18.9527 3.96414C18.3929 4.23168 17.8575 4.68796 16.7867 5.60048ZM28.6536 17.2605C29.2098 16.7043 29.2098 15.8025 28.6536 15.2463C28.0975 14.6901 27.1955 14.6901 26.6394 15.2463L18.1515 23.7342L15.3606 20.9433C14.8044 20.3872 13.9026 20.3872 13.3464 20.9433C12.7902 21.4995 12.7902 22.4012 13.3464 22.9576L17.1444 26.7556C17.7006 27.3117 18.6023 27.3117 19.1587 26.7556L28.6536 17.2605Z" fill="#9E4982"/>
                                    </svg>

                                </div>
                                <h5>Religious & Community Stakeholders</h5>
                                <h6>Faith-based volunteers and community members supporting children and families.</h6>
                            </div>
                                
                        </div>

                        <div>
                            <div class="green-bg">
                                <div class="d-flex mb-2">
                                    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7867 5.60048C16.3605 5.96365 16.1474 6.14527 15.9199 6.2978C15.3982 6.64745 14.8123 6.89012 14.1962 7.01176C13.9274 7.06484 13.6483 7.0871 13.0901 7.13164C11.6877 7.24357 10.9865 7.29952 10.4015 7.50616C9.0484 7.98408 7.98408 9.0484 7.50616 10.4015C7.29952 10.9865 7.24357 11.6877 7.13164 13.0901C7.0871 13.6483 7.06484 13.9274 7.01176 14.1962C6.89012 14.8123 6.64745 15.3982 6.2978 15.9199C6.14527 16.1474 5.96367 16.3605 5.60048 16.7867C4.68796 17.8575 4.23168 18.3929 3.96414 18.9527C3.34529 20.2475 3.34529 21.7525 3.96414 23.0473C4.2317 23.6072 4.68796 24.1425 5.60048 25.2133C5.96362 25.6394 6.14527 25.8526 6.2978 26.0801C6.64745 26.6018 6.89012 27.1877 7.01176 27.8038C7.06484 28.0726 7.0871 28.3518 7.13164 28.9098C7.24357 30.3123 7.29952 31.0135 7.50616 31.5985C7.98408 32.9516 9.0484 34.016 10.4015 34.4939C10.9865 34.7004 11.6877 34.7564 13.0901 34.8684C13.6483 34.9129 13.9274 34.9353 14.1962 34.9883C14.8123 35.1099 15.3982 35.3526 15.9199 35.7023C16.1474 35.8547 16.3605 36.0364 16.7867 36.3995C17.8575 37.3121 18.3929 37.7683 18.9527 38.0359C20.2475 38.6547 21.7525 38.6547 23.0473 38.0359C23.6072 37.7683 24.1425 37.3121 25.2133 36.3995C25.6394 36.0364 25.8526 35.8547 26.0801 35.7023C26.6018 35.3526 27.1877 35.1099 27.8038 34.9883C28.0726 34.9353 28.3518 34.9129 28.9098 34.8684C30.3123 34.7564 31.0135 34.7004 31.5985 34.4939C32.9516 34.016 34.016 32.9516 34.4939 31.5985C34.7004 31.0135 34.7564 30.3123 34.8684 28.9098C34.9129 28.3518 34.9353 28.0726 34.9883 27.8038C35.1099 27.1877 35.3526 26.6018 35.7023 26.0801C35.8547 25.8526 36.0364 25.6394 36.3995 25.2133C37.3121 24.1425 37.7683 23.6072 38.0359 23.0473C38.6547 21.7525 38.6547 20.2475 38.0359 18.9527C37.7683 18.3929 37.3121 17.8575 36.3995 16.7867C36.0364 16.3605 35.8547 16.1474 35.7023 15.9199C35.3526 15.3982 35.1099 14.8123 34.9883 14.1962C34.9353 13.9274 34.9129 13.6483 34.8684 13.0901C34.7564 11.6877 34.7004 10.9865 34.4939 10.4015C34.016 9.0484 32.9516 7.98408 31.5985 7.50616C31.0135 7.29952 30.3123 7.24357 28.9098 7.13164C28.3518 7.0871 28.0726 7.06484 27.8038 7.01176C27.1877 6.89012 26.6018 6.64745 26.0801 6.2978C25.8526 6.14527 25.6394 5.96367 25.2133 5.60048C24.1425 4.68796 23.6072 4.2317 23.0473 3.96414C21.7525 3.34529 20.2475 3.34529 18.9527 3.96414C18.3929 4.23168 17.8575 4.68796 16.7867 5.60048ZM28.6536 17.2605C29.2098 16.7043 29.2098 15.8025 28.6536 15.2463C28.0975 14.6901 27.1955 14.6901 26.6394 15.2463L18.1515 23.7342L15.3606 20.9433C14.8044 20.3872 13.9026 20.3872 13.3464 20.9433C12.7902 21.4995 12.7902 22.4012 13.3464 22.9576L17.1444 26.7556C17.7006 27.3117 18.6023 27.3117 19.1587 26.7556L28.6536 17.2605Z" fill="#00C8B3"/>
                                    </svg>
                                </div>
                                <h5>Educators & Learning Facilitators</h5>
                                <h6>Shelta SuperKids is a national platform designed to discover, celebrate and empower Nigerian </h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="duration-period">
            <div class="container">
                <h3>Programme Duration & Commitment</h3>
                <h6>Clear expectations to help you plan your time and participation with confidence.</h6>
                <div class="container">
                    <div class="row duration-time">
                        <div class="col-md-4">
                        <span>
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="40" height="40" rx="20" fill="#F5F7FA"/>
                                <path d="M30 20C30 25.5228 25.5228 30 20 30C14.4771 30 10 25.5228 10 20C10 14.4771 14.4771 10 20 10C25.5228 10 30 14.4771 30 20Z" fill="#2EBFCA"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M20 15.25C20.4142 15.25 20.75 15.5858 20.75 16V19.6893L23.0303 21.9697C23.3232 22.2626 23.3232 22.7374 23.0303 23.0303C22.7374 23.3232 22.2626 23.3232 21.9697 23.0303L19.4697 20.5303C19.329 20.3897 19.25 20.1989 19.25 20V16C19.25 15.5858 19.5858 15.25 20 15.25Z" fill="white"/>
                            </svg>
                        </span>
                        <small>8 weeks duration</small>
                        </div>
                        <div class="col-md-4">
                            <span>
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="40" height="40" rx="20" fill="#F5F7FA"/>
                                    <path d="M15.7508 10.5C15.7508 10.0858 15.415 9.75 15.0008 9.75C14.5866 9.75 14.2508 10.0858 14.2508 10.5V12.0793C12.8115 12.1945 11.8666 12.4774 11.1724 13.1716C10.4782 13.8658 10.1953 14.8107 10.0801 16.25H29.9215C29.8063 14.8107 29.5234 13.8658 28.8292 13.1716C28.135 12.4774 27.1901 12.1945 25.7508 12.0793V10.5C25.7508 10.0858 25.415 9.75 25.0008 9.75C24.5866 9.75 24.2508 10.0858 24.2508 10.5V12.0129C23.5855 12 22.8398 12 22.0008 12H18.0008C17.1618 12 16.4161 12 15.7508 12.0129V10.5Z" fill="#2EBFCA"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M30 20V22C30 25.7712 30 27.6569 28.8284 28.8284C27.6569 30 25.7712 30 22 30H18C14.2288 30 12.3432 30 11.1716 28.8284C10 27.6569 10 25.7712 10 22V20C10 19.161 10 18.4153 10.0129 17.75H29.9871C30 18.4153 30 19.161 30 20ZM24.5 26C25.3284 26 26 25.3284 26 24.5C26 23.6716 25.3284 23 24.5 23C23.6716 23 23 23.6716 23 24.5C23 25.3284 23.6716 26 24.5 26Z" fill="#2EBFCA"/>
                                </svg>
                            </span>
                            <small>10th April – May 8</small>
                        </div>
                        <div class="col-md-4">
                            <span>
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="40" height="40" rx="20" fill="#F5F7FA"/>
                                    <path d="M30 20C30 25.5228 25.5228 30 20 30C14.4771 30 10 25.5228 10 20C10 14.4771 14.4771 10 20 10C25.5228 10 30 14.4771 30 20Z" fill="#2EBFCA"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M20 15.25C20.4142 15.25 20.75 15.5858 20.75 16V19.6893L23.0303 21.9697C23.3232 22.2626 23.3232 22.7374 23.0303 23.0303C22.7374 23.3232 22.2626 23.3232 21.9697 23.0303L19.4697 20.5303C19.329 20.3897 19.25 20.1989 19.25 20V16C19.25 15.5858 19.5858 15.25 20 15.25Z" fill="white"/>
                                    </svg>
                            </span>
                            <small>3 - 5 Hours</small>
                        </div>
                    </div>
                    <div class="otg">
                        <p>All volunteers receive orientation, guidance, and ongoing support throughout the programme.</p>
                    </div>
                    <div class="mt-5">
                        <button class="btn becomeBtn" @click="routeTo('/volunteer-register')">Become a volunteer</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="benefit-holder">
            <div class="container">
                <h3 class="standard-header">Superkids Volunteer Benefits</h3>
                <h6 class="sub-header col-md-8 m-auto">
                    Volunteering with Shelta SuperKids offers both personal and community value.
                </h6>
                <div class="benefit-item-holder">
                    <div class="benefit-item marginta-bene">
                        <span>
                            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7867 5.60048C16.3605 5.96365 16.1474 6.14527 15.9199 6.2978C15.3982 6.64745 14.8123 6.89012 14.1962 7.01176C13.9274 7.06484 13.6483 7.0871 13.0901 7.13164C11.6877 7.24357 10.9865 7.29952 10.4015 7.50616C9.0484 7.98408 7.98408 9.0484 7.50616 10.4015C7.29952 10.9865 7.24357 11.6877 7.13164 13.0901C7.0871 13.6483 7.06484 13.9274 7.01176 14.1962C6.89012 14.8123 6.64745 15.3982 6.2978 15.9199C6.14527 16.1474 5.96367 16.3605 5.60048 16.7867C4.68796 17.8575 4.23168 18.3929 3.96414 18.9527C3.34529 20.2475 3.34529 21.7525 3.96414 23.0473C4.2317 23.6072 4.68796 24.1425 5.60048 25.2133C5.96362 25.6394 6.14527 25.8526 6.2978 26.0801C6.64745 26.6018 6.89012 27.1877 7.01176 27.8038C7.06484 28.0726 7.0871 28.3518 7.13164 28.9098C7.24357 30.3123 7.29952 31.0135 7.50616 31.5985C7.98408 32.9516 9.0484 34.016 10.4015 34.4939C10.9865 34.7004 11.6877 34.7564 13.0901 34.8684C13.6483 34.9129 13.9274 34.9353 14.1962 34.9883C14.8123 35.1099 15.3982 35.3526 15.9199 35.7023C16.1474 35.8547 16.3605 36.0364 16.7867 36.3995C17.8575 37.3121 18.3929 37.7683 18.9527 38.0359C20.2475 38.6547 21.7525 38.6547 23.0473 38.0359C23.6072 37.7683 24.1425 37.3121 25.2133 36.3995C25.6394 36.0364 25.8526 35.8547 26.0801 35.7023C26.6018 35.3526 27.1877 35.1099 27.8038 34.9883C28.0726 34.9353 28.3518 34.9129 28.9098 34.8684C30.3123 34.7564 31.0135 34.7004 31.5985 34.4939C32.9516 34.016 34.016 32.9516 34.4939 31.5985C34.7004 31.0135 34.7564 30.3123 34.8684 28.9098C34.9129 28.3518 34.9353 28.0726 34.9883 27.8038C35.1099 27.1877 35.3526 26.6018 35.7023 26.0801C35.8547 25.8526 36.0364 25.6394 36.3995 25.2133C37.3121 24.1425 37.7683 23.6072 38.0359 23.0473C38.6547 21.7525 38.6547 20.2475 38.0359 18.9527C37.7683 18.3929 37.3121 17.8575 36.3995 16.7867C36.0364 16.3605 35.8547 16.1474 35.7023 15.9199C35.3526 15.3982 35.1099 14.8123 34.9883 14.1962C34.9353 13.9274 34.9129 13.6483 34.8684 13.0901C34.7564 11.6877 34.7004 10.9865 34.4939 10.4015C34.016 9.0484 32.9516 7.98408 31.5985 7.50616C31.0135 7.29952 30.3123 7.24357 28.9098 7.13164C28.3518 7.0871 28.0726 7.06484 27.8038 7.01176C27.1877 6.89012 26.6018 6.64745 26.0801 6.2978C25.8526 6.14527 25.6394 5.96367 25.2133 5.60048C24.1425 4.68796 23.6072 4.2317 23.0473 3.96414C21.7525 3.34529 20.2475 3.34529 18.9527 3.96414C18.3929 4.23168 17.8575 4.68796 16.7867 5.60048ZM28.6536 17.2605C29.2098 16.7043 29.2098 15.8025 28.6536 15.2463C28.0975 14.6901 27.1955 14.6901 26.6394 15.2463L18.1515 23.7342L15.3606 20.9433C14.8044 20.3872 13.9026 20.3872 13.3464 20.9433C12.7902 21.4995 12.7902 22.4012 13.3464 22.9576L17.1444 26.7556C17.7006 27.3117 18.6023 27.3117 19.1587 26.7556L28.6536 17.2605Z" fill="#9E4982"/>
                            </svg>
                        </span>
                        <h5>Global recognition and certificates</h5>
                        <!-- <h6>Shelta SuperKids is a national platform designed to discover, celebrate and empower Nigerian.</h6> -->
                    </div>
                    <div class="benefit-item orange-bene">
                        <span>
                            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7867 5.60048C16.3605 5.96365 16.1474 6.14527 15.9199 6.2978C15.3982 6.64745 14.8123 6.89012 14.1962 7.01176C13.9274 7.06484 13.6483 7.0871 13.0901 7.13164C11.6877 7.24357 10.9865 7.29952 10.4015 7.50616C9.0484 7.98408 7.98408 9.0484 7.50616 10.4015C7.29952 10.9865 7.24357 11.6877 7.13164 13.0901C7.0871 13.6483 7.06484 13.9274 7.01176 14.1962C6.89012 14.8123 6.64745 15.3982 6.2978 15.9199C6.14527 16.1474 5.96367 16.3605 5.60048 16.7867C4.68796 17.8575 4.23168 18.3929 3.96414 18.9527C3.34529 20.2475 3.34529 21.7525 3.96414 23.0473C4.2317 23.6072 4.68796 24.1425 5.60048 25.2133C5.96362 25.6394 6.14527 25.8526 6.2978 26.0801C6.64745 26.6018 6.89012 27.1877 7.01176 27.8038C7.06484 28.0726 7.0871 28.3518 7.13164 28.9098C7.24357 30.3123 7.29952 31.0135 7.50616 31.5985C7.98408 32.9516 9.0484 34.016 10.4015 34.4939C10.9865 34.7004 11.6877 34.7564 13.0901 34.8684C13.6483 34.9129 13.9274 34.9353 14.1962 34.9883C14.8123 35.1099 15.3982 35.3526 15.9199 35.7023C16.1474 35.8547 16.3605 36.0364 16.7867 36.3995C17.8575 37.3121 18.3929 37.7683 18.9527 38.0359C20.2475 38.6547 21.7525 38.6547 23.0473 38.0359C23.6072 37.7683 24.1425 37.3121 25.2133 36.3995C25.6394 36.0364 25.8526 35.8547 26.0801 35.7023C26.6018 35.3526 27.1877 35.1099 27.8038 34.9883C28.0726 34.9353 28.3518 34.9129 28.9098 34.8684C30.3123 34.7564 31.0135 34.7004 31.5985 34.4939C32.9516 34.016 34.016 32.9516 34.4939 31.5985C34.7004 31.0135 34.7564 30.3123 34.8684 28.9098C34.9129 28.3518 34.9353 28.0726 34.9883 27.8038C35.1099 27.1877 35.3526 26.6018 35.7023 26.0801C35.8547 25.8526 36.0364 25.6394 36.3995 25.2133C37.3121 24.1425 37.7683 23.6072 38.0359 23.0473C38.6547 21.7525 38.6547 20.2475 38.0359 18.9527C37.7683 18.3929 37.3121 17.8575 36.3995 16.7867C36.0364 16.3605 35.8547 16.1474 35.7023 15.9199C35.3526 15.3982 35.1099 14.8123 34.9883 14.1962C34.9353 13.9274 34.9129 13.6483 34.8684 13.0901C34.7564 11.6877 34.7004 10.9865 34.4939 10.4015C34.016 9.0484 32.9516 7.98408 31.5985 7.50616C31.0135 7.29952 30.3123 7.24357 28.9098 7.13164C28.3518 7.0871 28.0726 7.06484 27.8038 7.01176C27.1877 6.89012 26.6018 6.64745 26.0801 6.2978C25.8526 6.14527 25.6394 5.96367 25.2133 5.60048C24.1425 4.68796 23.6072 4.2317 23.0473 3.96414C21.7525 3.34529 20.2475 3.34529 18.9527 3.96414C18.3929 4.23168 17.8575 4.68796 16.7867 5.60048ZM28.6536 17.2605C29.2098 16.7043 29.2098 15.8025 28.6536 15.2463C28.0975 14.6901 27.1955 14.6901 26.6394 15.2463L18.1515 23.7342L15.3606 20.9433C14.8044 20.3872 13.9026 20.3872 13.3464 20.9433C12.7902 21.4995 12.7902 22.4012 13.3464 22.9576L17.1444 26.7556C17.7006 27.3117 18.6023 27.3117 19.1587 26.7556L28.6536 17.2605Z" fill="#F8805D"/>
                            </svg>
                        </span>
                        <h5>Hands-on community leadership experience</h5>
                        <!-- <h6>Shelta SuperKids is a national platform designed to discover, celebrate and empower Nigerian.</h6> -->
                    </div>
                    <div class="benefit-item blue-bene">
                        <span>
                            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7867 5.60048C16.3605 5.96365 16.1474 6.14527 15.9199 6.2978C15.3982 6.64745 14.8123 6.89012 14.1962 7.01176C13.9274 7.06484 13.6483 7.0871 13.0901 7.13164C11.6877 7.24357 10.9865 7.29952 10.4015 7.50616C9.0484 7.98408 7.98408 9.0484 7.50616 10.4015C7.29952 10.9865 7.24357 11.6877 7.13164 13.0901C7.0871 13.6483 7.06484 13.9274 7.01176 14.1962C6.89012 14.8123 6.64745 15.3982 6.2978 15.9199C6.14527 16.1474 5.96367 16.3605 5.60048 16.7867C4.68796 17.8575 4.23168 18.3929 3.96414 18.9527C3.34529 20.2475 3.34529 21.7525 3.96414 23.0473C4.2317 23.6072 4.68796 24.1425 5.60048 25.2133C5.96362 25.6394 6.14527 25.8526 6.2978 26.0801C6.64745 26.6018 6.89012 27.1877 7.01176 27.8038C7.06484 28.0726 7.0871 28.3518 7.13164 28.9098C7.24357 30.3123 7.29952 31.0135 7.50616 31.5985C7.98408 32.9516 9.0484 34.016 10.4015 34.4939C10.9865 34.7004 11.6877 34.7564 13.0901 34.8684C13.6483 34.9129 13.9274 34.9353 14.1962 34.9883C14.8123 35.1099 15.3982 35.3526 15.9199 35.7023C16.1474 35.8547 16.3605 36.0364 16.7867 36.3995C17.8575 37.3121 18.3929 37.7683 18.9527 38.0359C20.2475 38.6547 21.7525 38.6547 23.0473 38.0359C23.6072 37.7683 24.1425 37.3121 25.2133 36.3995C25.6394 36.0364 25.8526 35.8547 26.0801 35.7023C26.6018 35.3526 27.1877 35.1099 27.8038 34.9883C28.0726 34.9353 28.3518 34.9129 28.9098 34.8684C30.3123 34.7564 31.0135 34.7004 31.5985 34.4939C32.9516 34.016 34.016 32.9516 34.4939 31.5985C34.7004 31.0135 34.7564 30.3123 34.8684 28.9098C34.9129 28.3518 34.9353 28.0726 34.9883 27.8038C35.1099 27.1877 35.3526 26.6018 35.7023 26.0801C35.8547 25.8526 36.0364 25.6394 36.3995 25.2133C37.3121 24.1425 37.7683 23.6072 38.0359 23.0473C38.6547 21.7525 38.6547 20.2475 38.0359 18.9527C37.7683 18.3929 37.3121 17.8575 36.3995 16.7867C36.0364 16.3605 35.8547 16.1474 35.7023 15.9199C35.3526 15.3982 35.1099 14.8123 34.9883 14.1962C34.9353 13.9274 34.9129 13.6483 34.8684 13.0901C34.7564 11.6877 34.7004 10.9865 34.4939 10.4015C34.016 9.0484 32.9516 7.98408 31.5985 7.50616C31.0135 7.29952 30.3123 7.24357 28.9098 7.13164C28.3518 7.0871 28.0726 7.06484 27.8038 7.01176C27.1877 6.89012 26.6018 6.64745 26.0801 6.2978C25.8526 6.14527 25.6394 5.96367 25.2133 5.60048C24.1425 4.68796 23.6072 4.2317 23.0473 3.96414C21.7525 3.34529 20.2475 3.34529 18.9527 3.96414C18.3929 4.23168 17.8575 4.68796 16.7867 5.60048ZM28.6536 17.2605C29.2098 16.7043 29.2098 15.8025 28.6536 15.2463C28.0975 14.6901 27.1955 14.6901 26.6394 15.2463L18.1515 23.7342L15.3606 20.9433C14.8044 20.3872 13.9026 20.3872 13.3464 20.9433C12.7902 21.4995 12.7902 22.4012 13.3464 22.9576L17.1444 26.7556C17.7006 27.3117 18.6023 27.3117 19.1587 26.7556L28.6536 17.2605Z" fill="#F8805D"/>
                            </svg>
                        </span>
                        <h5>Recognition as a SuperKids Community Volunteer</h5>
                        <!-- <h6>Shelta SuperKids is a national platform designed to discover, celebrate and empower Nigerian.</h6> -->
                    </div>
                    <div class="benefit-item green-bene">
                        <span>
                            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7867 5.60048C16.3605 5.96365 16.1474 6.14527 15.9199 6.2978C15.3982 6.64745 14.8123 6.89012 14.1962 7.01176C13.9274 7.06484 13.6483 7.0871 13.0901 7.13164C11.6877 7.24357 10.9865 7.29952 10.4015 7.50616C9.0484 7.98408 7.98408 9.0484 7.50616 10.4015C7.29952 10.9865 7.24357 11.6877 7.13164 13.0901C7.0871 13.6483 7.06484 13.9274 7.01176 14.1962C6.89012 14.8123 6.64745 15.3982 6.2978 15.9199C6.14527 16.1474 5.96367 16.3605 5.60048 16.7867C4.68796 17.8575 4.23168 18.3929 3.96414 18.9527C3.34529 20.2475 3.34529 21.7525 3.96414 23.0473C4.2317 23.6072 4.68796 24.1425 5.60048 25.2133C5.96362 25.6394 6.14527 25.8526 6.2978 26.0801C6.64745 26.6018 6.89012 27.1877 7.01176 27.8038C7.06484 28.0726 7.0871 28.3518 7.13164 28.9098C7.24357 30.3123 7.29952 31.0135 7.50616 31.5985C7.98408 32.9516 9.0484 34.016 10.4015 34.4939C10.9865 34.7004 11.6877 34.7564 13.0901 34.8684C13.6483 34.9129 13.9274 34.9353 14.1962 34.9883C14.8123 35.1099 15.3982 35.3526 15.9199 35.7023C16.1474 35.8547 16.3605 36.0364 16.7867 36.3995C17.8575 37.3121 18.3929 37.7683 18.9527 38.0359C20.2475 38.6547 21.7525 38.6547 23.0473 38.0359C23.6072 37.7683 24.1425 37.3121 25.2133 36.3995C25.6394 36.0364 25.8526 35.8547 26.0801 35.7023C26.6018 35.3526 27.1877 35.1099 27.8038 34.9883C28.0726 34.9353 28.3518 34.9129 28.9098 34.8684C30.3123 34.7564 31.0135 34.7004 31.5985 34.4939C32.9516 34.016 34.016 32.9516 34.4939 31.5985C34.7004 31.0135 34.7564 30.3123 34.8684 28.9098C34.9129 28.3518 34.9353 28.0726 34.9883 27.8038C35.1099 27.1877 35.3526 26.6018 35.7023 26.0801C35.8547 25.8526 36.0364 25.6394 36.3995 25.2133C37.3121 24.1425 37.7683 23.6072 38.0359 23.0473C38.6547 21.7525 38.6547 20.2475 38.0359 18.9527C37.7683 18.3929 37.3121 17.8575 36.3995 16.7867C36.0364 16.3605 35.8547 16.1474 35.7023 15.9199C35.3526 15.3982 35.1099 14.8123 34.9883 14.1962C34.9353 13.9274 34.9129 13.6483 34.8684 13.0901C34.7564 11.6877 34.7004 10.9865 34.4939 10.4015C34.016 9.0484 32.9516 7.98408 31.5985 7.50616C31.0135 7.29952 30.3123 7.24357 28.9098 7.13164C28.3518 7.0871 28.0726 7.06484 27.8038 7.01176C27.1877 6.89012 26.6018 6.64745 26.0801 6.2978C25.8526 6.14527 25.6394 5.96367 25.2133 5.60048C24.1425 4.68796 23.6072 4.2317 23.0473 3.96414C21.7525 3.34529 20.2475 3.34529 18.9527 3.96414C18.3929 4.23168 17.8575 4.68796 16.7867 5.60048ZM28.6536 17.2605C29.2098 16.7043 29.2098 15.8025 28.6536 15.2463C28.0975 14.6901 27.1955 14.6901 26.6394 15.2463L18.1515 23.7342L15.3606 20.9433C14.8044 20.3872 13.9026 20.3872 13.3464 20.9433C12.7902 21.4995 12.7902 22.4012 13.3464 22.9576L17.1444 26.7556C17.7006 27.3117 18.6023 27.3117 19.1587 26.7556L28.6536 17.2605Z" fill="#F8805D"/>
                            </svg>
                        </span>
                        <h5>Access to training and learning resources</h5>
                        <!-- <h6>Shelta SuperKids is a national platform designed to discover, celebrate and empower Nigerian.</h6> -->
                    </div>
                    <div class="benefit-item green-bene">
                        <span>
                            <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7867 5.60048C16.3605 5.96365 16.1474 6.14527 15.9199 6.2978C15.3982 6.64745 14.8123 6.89012 14.1962 7.01176C13.9274 7.06484 13.6483 7.0871 13.0901 7.13164C11.6877 7.24357 10.9865 7.29952 10.4015 7.50616C9.0484 7.98408 7.98408 9.0484 7.50616 10.4015C7.29952 10.9865 7.24357 11.6877 7.13164 13.0901C7.0871 13.6483 7.06484 13.9274 7.01176 14.1962C6.89012 14.8123 6.64745 15.3982 6.2978 15.9199C6.14527 16.1474 5.96367 16.3605 5.60048 16.7867C4.68796 17.8575 4.23168 18.3929 3.96414 18.9527C3.34529 20.2475 3.34529 21.7525 3.96414 23.0473C4.2317 23.6072 4.68796 24.1425 5.60048 25.2133C5.96362 25.6394 6.14527 25.8526 6.2978 26.0801C6.64745 26.6018 6.89012 27.1877 7.01176 27.8038C7.06484 28.0726 7.0871 28.3518 7.13164 28.9098C7.24357 30.3123 7.29952 31.0135 7.50616 31.5985C7.98408 32.9516 9.0484 34.016 10.4015 34.4939C10.9865 34.7004 11.6877 34.7564 13.0901 34.8684C13.6483 34.9129 13.9274 34.9353 14.1962 34.9883C14.8123 35.1099 15.3982 35.3526 15.9199 35.7023C16.1474 35.8547 16.3605 36.0364 16.7867 36.3995C17.8575 37.3121 18.3929 37.7683 18.9527 38.0359C20.2475 38.6547 21.7525 38.6547 23.0473 38.0359C23.6072 37.7683 24.1425 37.3121 25.2133 36.3995C25.6394 36.0364 25.8526 35.8547 26.0801 35.7023C26.6018 35.3526 27.1877 35.1099 27.8038 34.9883C28.0726 34.9353 28.3518 34.9129 28.9098 34.8684C30.3123 34.7564 31.0135 34.7004 31.5985 34.4939C32.9516 34.016 34.016 32.9516 34.4939 31.5985C34.7004 31.0135 34.7564 30.3123 34.8684 28.9098C34.9129 28.3518 34.9353 28.0726 34.9883 27.8038C35.1099 27.1877 35.3526 26.6018 35.7023 26.0801C35.8547 25.8526 36.0364 25.6394 36.3995 25.2133C37.3121 24.1425 37.7683 23.6072 38.0359 23.0473C38.6547 21.7525 38.6547 20.2475 38.0359 18.9527C37.7683 18.3929 37.3121 17.8575 36.3995 16.7867C36.0364 16.3605 35.8547 16.1474 35.7023 15.9199C35.3526 15.3982 35.1099 14.8123 34.9883 14.1962C34.9353 13.9274 34.9129 13.6483 34.8684 13.0901C34.7564 11.6877 34.7004 10.9865 34.4939 10.4015C34.016 9.0484 32.9516 7.98408 31.5985 7.50616C31.0135 7.29952 30.3123 7.24357 28.9098 7.13164C28.3518 7.0871 28.0726 7.06484 27.8038 7.01176C27.1877 6.89012 26.6018 6.64745 26.0801 6.2978C25.8526 6.14527 25.6394 5.96367 25.2133 5.60048C24.1425 4.68796 23.6072 4.2317 23.0473 3.96414C21.7525 3.34529 20.2475 3.34529 18.9527 3.96414C18.3929 4.23168 17.8575 4.68796 16.7867 5.60048ZM28.6536 17.2605C29.2098 16.7043 29.2098 15.8025 28.6536 15.2463C28.0975 14.6901 27.1955 14.6901 26.6394 15.2463L18.1515 23.7342L15.3606 20.9433C14.8044 20.3872 13.9026 20.3872 13.3464 20.9433C12.7902 21.4995 12.7902 22.4012 13.3464 22.9576L17.1444 26.7556C17.7006 27.3117 18.6023 27.3117 19.1587 26.7556L28.6536 17.2605Z" fill="#F8805D"/>
                            </svg>
                        </span>
                        <h5>Opportunity to contribute to meaningful social impact projects.</h5>
                        <!-- <h6>Shelta SuperKids is a national platform designed to discover, celebrate and empower Nigerian.</h6> -->
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="ready-join-holder">
            <div class="container">
                <h3 class="mb-4">Ready to Become a SuperKids Volunteer?</h3>
                <h6 class="col-md-8 m-auto">Join volunteers across Nigeria who are helping children discover their talents, build confidence, and thrive in their communities.</h6>

                <div class="mt-5">
                    <button class="becomeBtn btn" @click="routeTo('/volunteer-register')">Become a volunteer</button>
                </div>
            </div>
        </div>

        <footer>
            <div class="container"> 
                <div>
                    <img src="../assets/superkids/superkid-logo2.svg" alt="logo">
                </div>
                <div class="sphere">
                    <h5>Shelta SuperKids – Where Families Rise Together</h5>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <h6>Explore</h6>
                        <ul>
                            <li>How It Works</li>
                            <li>Weekly Challenges</li>
                            <li>SuperKids Festival</li>
                            <li>Rewards</li>
                            <li>Register</li>
                        </ul>
                    </div>
                    <div class="col-md-4">
                        <h6>Support</h6>
                        <ul>
                            <li class="mb-4">
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7 8.5L9.94202 10.2394C11.6572 11.2535 12.3428 11.2535 14.058 10.2394L17 8.5" stroke="#D6E2F0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M2.01577 13.4756C2.08114 16.5412 2.11383 18.0739 3.24496 19.2094C4.37608 20.3448 5.95033 20.3843 9.09883 20.4634C11.0393 20.5122 12.9607 20.5122 14.9012 20.4634C18.0497 20.3843 19.6239 20.3448 20.7551 19.2094C21.8862 18.0739 21.9189 16.5412 21.9842 13.4756C22.0053 12.4899 22.0053 11.5101 21.9842 10.5244C21.9189 7.45886 21.8862 5.92609 20.7551 4.79066C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09882 3.53656C5.95033 3.61566 4.37608 3.65521 3.24495 4.79065C2.11382 5.92608 2.08114 7.45885 2.01576 10.5244C1.99474 11.5101 1.99475 12.4899 2.01577 13.4756Z" stroke="#D6E2F0" stroke-width="1.5" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                                superkids@myshelta.com
                            </li>
                            <li>
                                <span>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.3789 2.27907 14.6926 2.78382 15.8877C3.06278 16.5481 3.20226 16.8784 3.21953 17.128C3.2368 17.3776 3.16334 17.6521 3.01642 18.2012L2 22L5.79877 20.9836C6.34788 20.8367 6.62244 20.7632 6.87202 20.7805C7.12161 20.7977 7.45185 20.9372 8.11235 21.2162C9.30745 21.7209 10.6211 22 12 22Z" stroke="#D6E2F0" stroke-width="1.5" stroke-linejoin="round"/>
                                        <path d="M8.58815 12.3773L9.45909 11.2956C9.82616 10.8397 10.2799 10.4153 10.3155 9.80826C10.3244 9.65494 10.2166 8.96657 10.0008 7.58986C9.91601 7.04881 9.41086 7 8.97332 7C8.40314 7 8.11805 7 7.83495 7.12931C7.47714 7.29275 7.10979 7.75231 7.02917 8.13733C6.96539 8.44196 7.01279 8.65187 7.10759 9.07169C7.51023 10.8548 8.45481 12.6158 9.91948 14.0805C11.3842 15.5452 13.1452 16.4898 14.9283 16.8924C15.3481 16.9872 15.558 17.0346 15.8627 16.9708C16.2477 16.8902 16.7072 16.5229 16.8707 16.165C17 15.8819 17 15.5969 17 15.0267C17 14.5891 16.9512 14.084 16.4101 13.9992C15.0334 13.7834 14.3451 13.6756 14.1917 13.6845C13.5847 13.7201 13.1603 14.1738 12.7044 14.5409L11.6227 15.4118" stroke="#D6E2F0" stroke-width="1.5"/>
                                    </svg>
                                    WhatsApp:(+2349088926200)
                                </span>
                            </li>
                            
                        </ul>
                    </div>
                    <div class="col-md-4">
                        <h6>Follow</h6>
                        <ul>
                            <li>
                                <a href="http://www.facebook.com/myshelta">
                                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g filter="url(#filter0_d_2713_8402)">
                                        <rect x="6" y="4" width="40" height="40" rx="20" fill="#2AB3E6" fill-opacity="0.16" shape-rendering="crispEdges"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.1818 22.3333C19.2041 22.3333 19 22.5252 19 23.4444V25.1111C19 26.0304 19.2041 26.2222 20.1818 26.2222H22.5455V32.8889C22.5455 33.8081 22.7495 34 23.7273 34H26.0909C27.0687 34 27.2727 33.8081 27.2727 32.8889V26.2222H29.9267C30.6683 26.2222 30.8594 26.0867 31.0631 25.4164L31.5696 23.7497C31.9185 22.6014 31.7035 22.3333 30.4332 22.3333H27.2727V19.5556C27.2727 18.9419 27.8018 18.4444 28.4545 18.4444H31.8182C32.7959 18.4444 33 18.2526 33 17.3333V15.1111C33 14.1918 32.7959 14 31.8182 14H28.4545C25.191 14 22.5455 16.4873 22.5455 19.5556V22.3333H20.1818Z" stroke="white" stroke-width="1.75" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <filter id="filter0_d_2713_8402" x="0" y="0" width="52" height="52" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                        <feOffset dy="2"/>
                                        <feGaussianBlur stdDeviation="3"/>
                                        <feComposite in2="hardAlpha" operator="out"/>
                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"/>
                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2713_8402"/>
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2713_8402" result="shape"/>
                                        </filter>
                                        </defs>
                                    </svg>
                                </a>

                                <a href="http://www.instagram.com/myshelta">
                                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g filter="url(#filter0_d_2713_8405)">
                                        <rect x="6" y="4" width="40" height="40" rx="20" fill="#2AB3E6" fill-opacity="0.16" shape-rendering="crispEdges"/>
                                        <path d="M16.5 24C16.5 19.5217 16.5 17.2825 17.8912 15.8912C19.2825 14.5 21.5217 14.5 26 14.5C30.4783 14.5 32.7175 14.5 34.1088 15.8912C35.5 17.2825 35.5 19.5217 35.5 24C35.5 28.4783 35.5 30.7175 34.1088 32.1088C32.7175 33.5 30.4783 33.5 26 33.5C21.5217 33.5 19.2825 33.5 17.8912 32.1088C16.5 30.7175 16.5 28.4783 16.5 24Z" stroke="white" stroke-width="1.5" stroke-linejoin="round"/>
                                        <path d="M30.5 24C30.5 26.4853 28.4853 28.5 26 28.5C23.5147 28.5 21.5 26.4853 21.5 24C21.5 21.5147 23.5147 19.5 26 19.5C28.4853 19.5 30.5 21.5147 30.5 24Z" stroke="white" stroke-width="1.5"/>
                                        <path d="M31.507 18.5H31.498" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <filter id="filter0_d_2713_8405" x="0" y="0" width="52" height="52" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                        <feOffset dy="2"/>
                                        <feGaussianBlur stdDeviation="3"/>
                                        <feComposite in2="hardAlpha" operator="out"/>
                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"/>
                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2713_8405"/>
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2713_8405" result="shape"/>
                                        </filter>
                                        </defs>
                                    </svg>
                                </a>

                                <a href="http://www.twitter.com/myshelta">
                                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g filter="url(#filter0_d_2713_8410)">
                                        <rect x="6" y="4" width="40" height="40" rx="20" fill="#2AB3E6" fill-opacity="0.16" shape-rendering="crispEdges"/>
                                        <path d="M17 33L24.5484 25.4516M24.5484 25.4516L17 15H22L27.4516 22.5484M24.5484 25.4516L30 33H35L27.4516 22.5484M35 15L27.4516 22.5484" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <filter id="filter0_d_2713_8410" x="0" y="0" width="52" height="52" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                        <feOffset dy="2"/>
                                        <feGaussianBlur stdDeviation="3"/>
                                        <feComposite in2="hardAlpha" operator="out"/>
                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"/>
                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2713_8410"/>
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2713_8410" result="shape"/>
                                        </filter>
                                        </defs>
                                    </svg>
                                </a>
                                <a href="http://www.linkedin.com/company/myshelta">
                                    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g filter="url(#filter0_d_2713_8413)">
                                        <rect x="6" y="4" width="40" height="40" rx="20" fill="#2AB3E6" fill-opacity="0.16" shape-rendering="crispEdges"/>
                                        <path d="M18.5 21.5H18C17.0572 21.5 16.5858 21.5 16.2929 21.7929C16 22.0858 16 22.5572 16 23.5V32C16 32.9428 16 33.4142 16.2929 33.7071C16.5858 34 17.0572 34 18 34H18.5C19.4428 34 19.9142 34 20.2071 33.7071C20.5 33.4142 20.5 32.9428 20.5 32V23.5C20.5 22.5572 20.5 22.0858 20.2071 21.7929C19.9142 21.5 19.4428 21.5 18.5 21.5Z" stroke="white" stroke-width="1.5"/>
                                        <path d="M20.5 16.25C20.5 17.4926 19.4926 18.5 18.25 18.5C17.0074 18.5 16 17.4926 16 16.25C16 15.0074 17.0074 14 18.25 14C19.4926 14 20.5 15.0074 20.5 16.25Z" stroke="white" stroke-width="1.5"/>
                                        <path d="M26.326 21.5H25.5C24.5572 21.5 24.0858 21.5 23.7929 21.7929C23.5 22.0858 23.5 22.5572 23.5 23.5V32C23.5 32.9428 23.5 33.4142 23.7929 33.7071C24.0858 34 24.5572 34 25.5 34H26C26.9428 34 27.4142 34 27.7071 33.7071C28 33.4142 28 32.9428 28 32L28.0001 28.5001C28.0001 26.8433 28.5281 25.5001 30.0879 25.5001C30.8677 25.5001 31.5 26.1717 31.5 27.0001V31.5001C31.5 32.4429 31.5 32.9143 31.7929 33.2072C32.0857 33.5001 32.5572 33.5001 33.5 33.5001H33.9987C34.9413 33.5001 35.4126 33.5001 35.7055 33.2073C35.9984 32.9145 35.9985 32.4432 35.9987 31.5006L36.0001 26.0002C36.0001 23.515 33.6364 21.5002 31.2968 21.5002C29.9649 21.5002 28.7767 22.1531 28.0001 23.174C28 22.5439 28 22.2289 27.8632 21.995C27.7765 21.8469 27.6531 21.7235 27.505 21.6369C27.2711 21.5 26.9561 21.5 26.326 21.5Z" stroke="white" stroke-width="1.5" stroke-linejoin="round"/>
                                        </g>
                                        <defs>
                                        <filter id="filter0_d_2713_8413" x="0" y="0" width="52" height="52" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                        <feOffset dy="2"/>
                                        <feGaussianBlur stdDeviation="3"/>
                                        <feComposite in2="hardAlpha" operator="out"/>
                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"/>
                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2713_8413"/>
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2713_8413" result="shape"/>
                                        </filter>
                                        </defs>
                                    </svg>
                                </a>
                            </li>
                            
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
        <div class="copy-right">
            <h4>© {{ year }} Shelta Impact Projects (SIP). All Rights Reserved.</h4>
        </div>
    </div>
</template>



<script>
import { Service } from "../store/service";
const Api = new Service();

export default {
  name: "SuperkidHome",
  components: {
  },
  data() {
    return {
      loader: false,
      year: null,
    };
  },
  mounted() {
    this.year = new Date().getFullYear();
  },
  methods: {
    routeTo(route) {
        this.$router.push(route);
    }
  }
};
</script>

<style scoped lang="scss">

.top-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    background: #ffffff;
    padding: 30px 15px;
    box-shadow: 0px 2px 8px 0px #00000000;
    // border: 1px solid #F5F7FA;
    button {
        background: #2EBFCA;
        color: #ffffff;
        font-family: Lato;
        font-weight: 600;
        font-size: 18px;
        padding-left: 20px;
        padding-right: 20px;
        border-radius: 50px;
    }
}

.hero-section{
//   background-image: linear-gradient(270deg, rgba(245, 247, 250, 0.15) 27.4%, rgba(123, 124, 125, 0.435) 42.55%, rgba(0, 0, 0, 0.72) 57.69%), 
//     url('../assets/superkids/hero-superkid.png');
//     background-size: cover;
//   background-position: center;
//   background-repeat: no-repeat;
//   min-height: 100vh; 

    background-image: linear-gradient(180deg, rgba(26, 24, 24, 0.45) 100%, rgba(128, 120, 120, 0.45) 100%) ,url('../assets/superkids/hero-bg-mobil.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    min-height: 100vh; 
    // height: 500px;

}
@media (min-width: 992px) {
   .hero-section {
        background-image: linear-gradient(270deg, rgba(245, 247, 250, 0.15) 27.4%, rgba(123, 124, 125, 0.435) 42.55%, rgba(0, 0, 0, 0.72) 57.69%), 
        url('../assets/superkids/hero-superkid.png');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    
        min-height: 100vh;
   }

  
}
.hero-text-holder {
    padding: 15px;
    margin-top: 130px;
    position: relative;
    .shine {
        position: absolute;
        top: -118px;
        left: -98px;
    }
    h3 {
        font-family: Poppins;
        font-weight: 700;
        font-size: 45px;
        line-height: 52px;
        text-align: left;
        color: #ffffff;

    }
    p {
        font-family: Poppins;
        font-weight: 600;
        font-size: 20px;
        line-height: 34px;
        text-align: left;
        color: #ffffff;
    }
}

.becomeBtn {
    background: #2EBFCA;
    color: #ffffff;
    height: 50px;
    width: 237px;
    font-family: Lato;
    font-weight: 600;
    font-size: 18px;
    border-radius: 50px;
    outline: 0;
    box-shadow: none;

}


.whatIsSuperKidHolder {
    padding-top: 80px;
}
.left-what {
    h3 {
        font-family: Poppins;
        font-weight: 700;
        font-size: 52px;
        line-height: 60px;
        color: #1C2B3A;
        text-align: left;
        margin-bottom: 30px;
    }
    p {
        font-family: Lato;
        font-weight: 500;
        font-size: 18px;
        line-height: 34px;
        color: #5D6F7C;
        text-align: justify;
    }
}
.right-what {
    background: #F5F7FA;
    border: 2px solid #F5F7FA;
    border-radius: 16px;
    padding: 24px;
}
.right-what-list {
    display: flex;
    align-items: baseline;
    gap: 15px;
    background: #ffffff;
    border-radius: 16px;
    padding: 16px;
    h5 {
        font-family: Lato;
        font-weight: 700;
        font-size: 20px;
        line-height: 28px;
        color: #1C2B3A;
        text-align: left;
        margin-bottom: 15px;
    }
    h6 {
        font-family: Lato;
        font-weight: 700;
        font-size: 18px;
        line-height: 28px;
        color: #5D6F7C;
        text-align: left;
    }
}
.right-what-list:not(:last-child)  {
    margin-bottom: 15px;
}

.why-volunteer-holder {
    margin-top: 100px;

}
.standard-header {
    font-family: Poppins;
    font-weight: 700;
    font-size: 52px;
    line-height: 65px;
    color: #1C2B3A;
    text-align: center;
}
.sub-header {
    font-family: Lato;
    font-weight: 500;
    font-size: 20px;
    line-height: 32px;
    color: #5D6F7C;
    text-align: center;

}

.why-cards {
    display: flex;
    overflow-x: scroll;
    margin-top: 80px;
    margin-bottom: 80px;
}
.why-card {
    width: 100%;
    min-width: 214px;
    border-radius: 20px;
    border: 2px solid transparent;
    padding: 10px;
    h5 {
        font-family: Lato;
        font-weight: 700;
        font-size: 18px;
        line-height: 30px;
        color: #1C2B3A;
        text-align: center;
        margin-bottom: 0;

    }
    h6 {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        color: #5D6F7C;
        text-align: center;
        margin-bottom: 0px;
    }
}
.why-card:not(:last-child) {
    margin-right: 20px;
}
.orange-card {
    border: 2px solid #F8805D; 
}
.blue-card {
    border: 2px solid #0870AD; 
}
.green-card {
    border: 2px solid #00C8B3; 
}
.marginta-card {
    border: 2px solid #9E4982; 
}
.sky-blue-card {
    border: 2px solid #2AB3E6; 
}

.who_can_apply {
    margin-top: 100px;
}


.hide-scrollbar {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  overflow-y: scroll; /* Ensure the element is scrollable */
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;  /* Chrome, Safari, Opera */
}
.orange-bg {
    background: #FEF6F5;
    padding: 24px 16px;
    border-radius: 20px;
    // text-align: left;
}.marginta-bg {
    background: #FBF7FC;
    padding: 24px 16px;
    border-radius: 20px;
    // text-align: left;
}
.green-bg {
    background: #F5FFFE;
    padding: 24px 16px;
    border-radius: 20px;
    // text-align: left;
}
.green-bg, .marginta-bg, .orange-bg{
    margin-bottom: 20px;
    h5 {
        font-family: Lato;
        font-weight: 700;
        font-size: 18px;
        line-height: 25px;
        color: #1C2B3A;
        text-align: left;
        margin-bottom: 15px;
    }
    h6 {
        font-family: Lato;
        font-weight: 700;
        font-size: 16px;
        line-height: 25px;
        color: #5D6F7C;
        text-align: left;
    }
}

.duration-period {
    background: #E8F7FC;
    border: 1px solid #F5F7FA;
    border-radius: 8px;
    padding-top: 100px;
    padding-bottom: 100px;

    h3 {
        font-family: Poppins;
        font-weight: 700;
        font-size: 32px;
        line-height: 40px;
        color: #1C2B3A;
        text-align: center;
    }
    h6 {
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        line-height: 40px;
        color: #5D6F7C;
        text-align: center;
        margin-bottom: 0;
    }
}

.duration-time {
    margin-top: 40px !important;
    small {
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        line-height: 40px;
        color: #1C2B3A;
    }
}

.benefit-holder {
    padding-top: 60px;
    padding-bottom: 60px;
}
.benefit-item-holder {
    display: flex;
    overflow-x: scroll;
    margin-top: 80px;
    margin-bottom: 80px;
}
.benefit-item {
    min-width: 247px;
    width: 100%;
    padding: 24px 16px;
    border-radius: 20px;
    text-align: left;
    h5 {
        font-family: Lato;
        font-weight: 700;
        font-size: 16px;
        color: #1C2B3A;
        line-height: 25px;
    }
    h6 {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        color: #5D6F7C;
        line-height: 21px;
    }
}
.benefit-item:not(:last-child) {
    margin-right: 20px;
}
.marginta-bene {
    background: #F6ECF9;
}
.blue-bene {
    background: #E8F7FC;
}
.orange-bene {
    background: #FDE8E7;
}
.green-bene {
    background: #E5FFFC;
}

.ready-join-holder {
    background: #e6f9fa;
    padding-top: 80px;
    padding-bottom: 80px;
    h3 {
        font-family: Poppins;
        font-weight: 700;
        font-size: 36px;
        line-height: 30px;
        color: #1C2B3A;
        text-align: center;
    }
    h6 {
        font-family: Lato;
        font-weight: 500;
        font-size: 18px;
        line-height: 28px;
        color: #5D6F7C;
        text-align: center;
    }
}

.otg {
    margin-top: 50px;
    p {
        font-family: Lato;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        background: #ffffff;
        border-radius: 50px;
        padding: 20px 15px;
        width: fit-content;
        margin: auto;
    }
}

footer {
    background: #0B1E3D;
    h6 {
        font-family: Poppins;
        font-weight: 500;
        font-size: 16px;
        line-height: 30px;
        color: #FFFFFF;
        text-align: left;
        padding-left: 40px;
    }

    li {
        list-style: none;
        font-family: Poppins;
        font-weight: 400;
        font-size: 15px;
        line-height: 30px;
        color: #FFFFFF;
        text-align: left;

    }
}

.sphere {
    width: 100%;
    max-width: 672px;
    height: 249px;
    background-image: url('../assets/superkids/shinning-shpare.svg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    margin: auto;
    h5 {
        font-family: Poppins;
        font-weight: 500;
        font-size: 24px;
        line-height: 30px;
        color: #ffffff;
        text-align: center;
        position: absolute;
        bottom: 50%;
        max-width: calc(100vw - 40px); 
        margin: auto;
        /* Forces the break */
        white-space: normal; 
        overflow-wrap: break-word
    }
}

.copy-right {
    border-top: 1px solid #EBEBEB0F;
    background-color: #0B1E3D;
    padding: 24px 15px;
    h4 {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 30px;
        color: #ffffff;
        text-align: center;
    }
}

@media only screen and (max-width: 599px) {
    .hero-text-holder {
        .shine {
            top: -106px;
            left: -79px;
        }
    }
    .hero-text-holder {
        margin-bottom: 40px;
    }
    .left-what {
        h3 {
            font-size: 38px;
            line-height: 48px;
        }
    }
    .standard-header {
        font-size: 33px;
        line-height: 44px;
    }
    .ready-join-holder {
        h3 {
            font-size: 32px;
            line-height: 44px;
        }
    }
    footer {
        ul {
            margin-bottom: 25px;
        }
    }
    .otg {
        p {
            border-radius: 8px;
        }
    }
}



// .contain {
//     width: 100%;
// }

// @media (min-width: 1200px) {
//     .contain {
//         min-width: 1140px !important;
//     }
// }
// @media (min-width: 992px) {
//     .contain {
//         min-width: 960px !important;
//     }
// }
// @media (min-width: 786px) {
//     .contain {
//         min-width: 720px !important;
//     }
// }
// @media (min-width: 576px) {
//     .contain {
//         min-width: 540px !important;
//     }
// }
</style>